import PropTypes from 'prop-types';
import Tooltip from 'infrastructure/js/components/tooltip/tooltip';

require('./iconWithTooltipCell.scss');

export default function IconWithTooltipCell(props) {

  if (props.value?.icon) {
    let {icon: Icon, tooltip, className} = props.value;

    return <Tooltip
      placement="top"
      value={tooltip}
      delayShow={500}>
      <span>
        <Icon className={className}/>
      </span>

    </Tooltip>
  }
  return null;
}

IconWithTooltipCell.propTypes = {
  value: PropTypes.object.isRequired,
};

